import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getReadDocument, setCollapse } from 'redux/actions/documentActions';
import { Breadcrumb as BreadcrumbComponent } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { removeBreadcrumb } from 'redux/actions/layoutActions';
import { selectCurrentClient } from 'redux/actions/clientActions';

import { BreadcrumbWrapper, BreadcrumbItemContainer } from './styles';

const Breadcrumb = ({ className }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isCollapse } = useSelector((state) => state.document);
  const { breadcrumbs } = useSelector((state) => state.layout);
  const { isCustomer } = useSelector((state) => state.auth);
  const handleLink = ({ link, active, isModify, client }) => {
    if (link === 'documentations-client' && isCustomer) {
      dispatch(setCollapse(!isCollapse));
    } else if (!active && !isModify) {
      history.push(`${link}`);
      dispatch(removeBreadcrumb());
    }
    if (client) {
      dispatch(selectCurrentClient(client));
    }
    dispatch(getReadDocument(null));
  };
  return (
    <BreadcrumbWrapper className={className}>
      <BreadcrumbComponent>
        {breadcrumbs.map((item) => (
          <BreadcrumbItemContainer
            key={item.link}
            active={item.active}
            aria-hidden="true"
            onClick={() => handleLink(item)}
            className="text-uppercase"
            isModify={item.isModify}
          >
            {t(item.label)}
          </BreadcrumbItemContainer>
        ))}
      </BreadcrumbComponent>
    </BreadcrumbWrapper>
  );
};

Breadcrumb.defaultProps = {
  className: '',
};

Breadcrumb.propTypes = {
  className: PropTypes.string,
};

export default Breadcrumb;
